export default __webpack_public_path__ + "static/media/placement-introduction.cc837511.gif";